import React from "react"
import { Box, ExpandableMarkup } from "@mallardbay/lib-react-components"

import { useCurrentOutfitter } from "~components/providers/current-outfitter-provider"
import COPY from "~config/copy-constants"
import { TEST_IDS } from "~config/test-ids"

export default function OutfitterAbout() {
    const { currentOutfitter } = useCurrentOutfitter()
    const styles = useStyles()

    return (
        <Box style={styles.root} data-testid={TEST_IDS.OUTFITTER_ABOUT}>
            <ExpandableMarkup
                markup={currentOutfitter.about}
                title={COPY.ABOUT}
                isLargeTitle
            />
        </Box>
    )
}

function useStyles() {
    return {
        root: {
            lineHeight: "1.5",
        },
    }
}
